// This is a helper function that would be replaced with something more explicit
//      after this experiment is completed
// We check to see if any of the included fields have data in Confidence Signals
// The only source for these fields is from MLS Listings Remarks
// Therefore, if there is a value for any of these fields, there must be an MLS listing
import { GetValidataQuery_validata_getConfidenceSignalsByFields_confidenceSignals } from '../api/queries/__generated__/GetValidataQuery';

export function isPreviouslyListed(
  confidenceSignals: Array<GetValidataQuery_validata_getConfidenceSignalsByFields_confidenceSignals>,
): boolean {
  // Define the attributes that indicate a previous listing
  // Note: this is not a comprehensive list of listing remarks derived attributes
  //   rather a subset that are ONLY populated ahead of onboarding via listing remarks
  const listingIndicators = [
    // Upgrades
    'has_upgrades',

    // Exterior Features
    'has_nice_curb_appeal',
    'has_nice_backyard',
    'has_resort_style',
    'has_private_spa',

    // Interior Features
    'has_air_conditioning',
    'has_fireplace',
  ];

  // If confidenceSignals array is empty, which would be an unexpected error state technically,
  // fallback to returning True so that we err on the side of not showing the experiment pages
  if (confidenceSignals.length === 0) {
    return true;
  }

  // Presence of a confidenceSignal for an above attribute
  //   with any other source than NO_DATA indicates previous listing
  return confidenceSignals.some(
    (signal) =>
      listingIndicators.includes(signal.attributeName) &&
      signal.reason !== 'CONFIDENCE_REASON_NO_DATA',
  );
}
